var $db48c58cf8ddfba2$exports = {};
$db48c58cf8ddfba2$exports = {
    "(optional)": `(valgfritt)`,
    "(required)": `(obligatorisk)`
};


export {$db48c58cf8ddfba2$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
